import { message } from 'antd';
import axios, { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';
import { redirect } from 'react-router-dom';

// export const baseUrl = process.env.REACT_APP_BASE_URL || 'http://120.77.78.252'
export const baseUrl = process.env.REACT_APP_BASE_URL || 'https://dev.p.zhkzhy.com'
// 创建 axios 实例
const instance = axios.create({
    baseURL: baseUrl, // 替换为你的 API 基础 URL
    timeout: 1000000, // 请求超时时间
});

// 请求拦截器
instance.interceptors.request.use(
    (config: AxiosRequestConfig & { headers: AxiosHeaders }) => {

        // 在发送请求之前做些什么，比如添加 token
        const token = window.localStorage.getItem("token")
        if(token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    (response: AxiosResponse) => {
        // 对响应数据做些什么
        return response;
    },
    (error) => {
        // 对响应错误做些什么
        return Promise.reject(error);
    }
);

interface ApiResponse<T> {
    code: number;
    msg: string;
    data: T;
    errorCode: number;
    errMsg: string
}

interface GetRequestConfig extends AxiosRequestConfig {
    sclient?: boolean;
}

// GET 请求方法
export const iGet = async <T>(url: string, params?: any, config?: GetRequestConfig): Promise<ApiResponse<T> | undefined> => {
    try {
        const response = await instance.get<ApiResponse<T>>(url, { params, ...config });
        if(response.data.code === -4) {
            window.localStorage.removeItem("token")
            window.location.href = '/login'
            return;
        }
        if(response.data.code !== 0) {
            throw new Error(response.data.msg);
        } else {
            return response.data;
        }

    } catch (error: any) {
        if (!config?.sclient) {
            message.error(error.message || '系统异常，请稍后再试');
        }
        // throw error;
    }
};

// POST 请求方法
export const iPost = async <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T> | undefined> => {
    try {
        const response = await instance.post<ApiResponse<T>>(url, data, config);
        if(response.data.code === -4) {
            window.localStorage.removeItem("token")
            redirect('/login')
            return;
        }
        if(response.data.code !== 0 && response.data.code !== 200) {
            throw new Error(response.data.msg);
        } else {
            return response.data;
        }
    } catch (error:any) {
        message.error(error.message || '系统异常，请稍后再试');
        // throw error;
    }
};